// **************** Dynamic Header Height ********************
function updateHeaderHeight() {
  const header = document.querySelector('.shopify-section.shopify-section-group-header-group.section-header.shopify-section-header-sticky');
  
  const navigation = document.querySelector('.autify.header-navigation');
  
  if (header && navigation) {
    const headerHeight = header.offsetHeight+15;
    navigation.style.top = headerHeight/2 + 'px';
  }
}

// Update on load and resize
document.addEventListener('DOMContentLoaded', updateHeaderHeight);
window.addEventListener('resize', updateHeaderHeight);

// **************** Carousel Re-initialization for Recommendations ********************
function initializeCarousels() {
  const carousels = document.querySelectorAll('[data-carousel]');
  carousels.forEach(carousel => {
    const track = carousel.querySelector('[data-track]');
    const prevBtn = carousel.querySelector('[data-prev]');
    const nextBtn = carousel.querySelector('[data-next]');
    
    if (track && prevBtn && nextBtn) {
      let currentIndex = 0;
      const items = track.querySelectorAll('.autify-category-carousel-item');
      const itemWidth = items[0]?.offsetWidth || 300;
      const visibleItems = Math.floor(track.offsetWidth / itemWidth);
      
      function updateCarousel() {
        const translateX = -currentIndex * itemWidth;
        track.style.transform = `translateX(${translateX}px)`;
        
        // Update button states
        prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
        nextBtn.style.opacity = currentIndex >= items.length - visibleItems ? '0.5' : '1';
      }
      
      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
        }
      });
      
      nextBtn.addEventListener('click', () => {
        if (currentIndex < items.length - visibleItems) {
          currentIndex++;
          updateCarousel();
        }
      });
      
      // Initial setup
      updateCarousel();
    }
  });
}

// Initialize carousels on DOM load
document.addEventListener('DOMContentLoaded', initializeCarousels);

// Re-initialize carousels when recommendations load
document.addEventListener('DOMContentLoaded', () => {
  const productRecommendations = document.querySelector('product-recommendations');
  if (productRecommendations) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if recommendations content was added
          const hasRecommendations = productRecommendations.querySelector('.autify-category-carousel-wrapper');
          if (hasRecommendations) {
            // Small delay to ensure DOM is fully rendered
            setTimeout(initializeCarousels, 100);
          }
        }
      });
    });
    
    observer.observe(productRecommendations, {
      childList: true,
      subtree: true
    });
  }
});

// **************** Modal Navigation ********************
function initializeModalNavigation() {
  const modal = document.querySelector('.product-media-modal');
  if (!modal) return;
  
  // Check if already initialized
  if (modal.dataset.modalNavigationInitialized === 'true') return;
  
  const track = modal.querySelector('[data-modal-track]');
  const prevBtn = modal.querySelector('[data-modal-prev]');
  const nextBtn = modal.querySelector('[data-modal-next]');
  const currentSpan = modal.querySelector('.modal-current');
  
  if (!track || !prevBtn || !nextBtn) return;
  
  // Mark as initialized
  modal.dataset.modalNavigationInitialized = 'true';
  
  // Get all media items
  const mediaItems = Array.from(track.children);
  let currentIndex = 0;
  const totalItems = mediaItems.length;
  
  // Hide navigation if only one item
  if (totalItems <= 1) {
    const navContainer = modal.querySelector('[data-modal-nav-container]');
    if (navContainer) navContainer.style.display = 'none';
    return;
  }
  
  // Find which image was clicked by checking the modal opener
  // Try multiple ways to find the clicked modal opener
  let modalOpener = document.querySelector('.product__modal-opener[aria-expanded="true"]');
  if (!modalOpener) {
    // Try finding any modal opener that might be active
    modalOpener = document.querySelector('.product__modal-opener');
  }
  
  if (modalOpener) {
    const clickedMediaId = modalOpener.querySelector('[data-media-id]')?.getAttribute('data-media-id');
    
    if (clickedMediaId) {
      // Find the corresponding media item in the modal track
      const clickedItem = mediaItems.find(item => {
        // Check if the item has the same media-id
        const itemMediaId = item.getAttribute('data-media-id');
        return itemMediaId === clickedMediaId;
      });
      
      if (clickedItem) {
        currentIndex = mediaItems.indexOf(clickedItem);
      } else {
        mediaItems.map(item => item.getAttribute('data-media-id'))
      }
    }
  }
  
  function showImage(index) {
    
    // Add fade animation
    const currentItem = mediaItems[currentIndex];
    const targetItem = mediaItems[index];
    
    if (currentItem && targetItem && currentIndex !== index) {
      // Fade out current image
      currentItem.style.transition = 'opacity 0.3s ease';
      currentItem.style.opacity = '0';
      
      setTimeout(() => {
        // Hide current image
        currentItem.style.display = 'none';
        currentItem.style.opacity = '1';
        
        // Show target image
        targetItem.style.display = 'block';
        targetItem.style.opacity = '0';
        
        // Fade in target image
        setTimeout(() => {
          targetItem.style.transition = 'opacity 0.3s ease';
          targetItem.style.opacity = '1';
        }, 10);
      }, 300);
    } else {
      // Direct show/hide for initial load or same image
      mediaItems.forEach((item, i) => {
        item.style.display = i === index ? 'block' : 'none';
        item.style.opacity = '1';
      });
    }
    
    // Update counter
    if (currentSpan) currentSpan.textContent = index + 1;
    
    // Update button states
    prevBtn.style.opacity = index === 0 ? '0.5' : '1';
    nextBtn.style.opacity = index >= totalItems - 1 ? '0.5' : '1';
    
    currentIndex = index;
  }
  
  // Navigation event listeners
  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentIndex > 0) {
      showImage(currentIndex - 1);
    }
  });
  
  nextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentIndex < totalItems - 1) {
      showImage(currentIndex + 1);
    }
  });
  
  // Keyboard navigation
  const handleKeydown = (e) => {
    if (e.key === 'ArrowLeft' && currentIndex > 0) {
      e.preventDefault();
      showImage(currentIndex - 1);
    } else if (e.key === 'ArrowRight' && currentIndex < totalItems - 1) {
      e.preventDefault();
      showImage(currentIndex + 1);
    }
  };
  
  modal.addEventListener('keydown', handleKeydown);
  
  // Show the clicked image (or first if none found)
  showImage(currentIndex);
}

// Initialize when modal opens
document.addEventListener('DOMContentLoaded', () => {
  // Simple initialization on any modal-related click
  document.addEventListener('click', (e) => {
    if (e.target.closest('.product__modal-opener') || e.target.closest('[data-modal-toggle]')) {
      setTimeout(initializeModalNavigation, 100);
    }
  });
  
  // Also check if modal is already open
  setTimeout(() => {
    const modal = document.querySelector('.product-media-modal');
    if (modal) {
      initializeModalNavigation();
    }
  }, 500);
});

// **************** Carousel Script ********************
(function () {
  const carousels = document.querySelectorAll('[data-carousel]');
  if (!carousels.length) return;

  carousels.forEach(wrapper => {
    const track = wrapper.querySelector('[data-track]');
    const nextBtn = wrapper.querySelector('[data-next]');
    const prevBtn = wrapper.querySelector('[data-prev]');

    if (!track || !nextBtn || !prevBtn) return;

    const items = track.querySelectorAll('.autify-category-carousel-item');
    const totalItems = items.length;
    let currentIndex = 0;

    // function getItemsPerView() {
    //   return window.innerWidth <= 768 ? 1.35 : 4;
    // }

    function getItemsPerView() {
        if (window.innerWidth < 768) {
            return 1;
        } else if (window.innerWidth >= 768 && window.innerWidth <= 995) {
            return 3;
        } else {
            return 4;
        }
    }

    const isDesktop = window.innerWidth > 995;

    // Hide arrows ONLY on desktop if total items <= 4
    if (isDesktop && totalItems <= 4) {
      nextBtn.style.display = 'none';
      prevBtn.style.display = 'none';
      return;
    }

    function updateCarousel() {
      const itemsPerView = getItemsPerView();
      const itemWidth = 100 / itemsPerView;
      const translateX = -(currentIndex * itemWidth);
      track.style.transform = `translateX(${translateX}%)`;

      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= totalItems - itemsPerView;
    }

    nextBtn.addEventListener('click', () => {
      const itemsPerView = getItemsPerView();
      const maxIndex = totalItems - itemsPerView;
      if (currentIndex < maxIndex) {
        const advance = Math.min(itemsPerView - 2, maxIndex - currentIndex);
        currentIndex += Math.max(1, advance);
        updateCarousel();
      }
    });

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        const itemsPerView = getItemsPerView();
        const goBack = Math.min(itemsPerView - 2, currentIndex);
        currentIndex -= Math.max(1, goBack);
        updateCarousel();
      }
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const itemsPerView = getItemsPerView();
        const maxIndex = totalItems - itemsPerView;

        // Re-check arrow visibility on resize (if switching between mobile/desktop)
        if (window.innerWidth > 768 && totalItems <= 4) {
          nextBtn.style.display = 'none';
          prevBtn.style.display = 'none';
        } else {
          nextBtn.style.display = '';
          prevBtn.style.display = '';
        }

        if (currentIndex > maxIndex) {
          currentIndex = Math.max(0, maxIndex);
        }
        updateCarousel();
      }, 250);
    });

    // Touch + Mouse Drag
    let isDragging = false;
    let startX = 0;
    let endX = 0;

    function startDrag(x) {
      isDragging = true;
      startX = x;
    }

    function moveDrag(x) {
      if (!isDragging) return;
      endX = x;
    }

    function endDrag() {
      if (!isDragging) return;

      const diffX = endX - startX;
      const threshold = 50;

      if (diffX > threshold && currentIndex > 0) {
        currentIndex -= 1;
      } else if (diffX < -threshold && currentIndex < totalItems - getItemsPerView()) {
        currentIndex += 1;
      }

      updateCarousel();
      isDragging = false;
    }

    track.addEventListener('touchstart', e => startDrag(e.touches[0].clientX));
    track.addEventListener('touchmove', e => moveDrag(e.touches[0].clientX));
    track.addEventListener('touchend', endDrag);

    track.addEventListener('mousedown', e => startDrag(e.clientX));
    track.addEventListener('mousemove', e => moveDrag(e.clientX));
    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    // Prevent image dragging ghost effect
    items.forEach(item => {
      item.addEventListener('dragstart', e => e.preventDefault());
    });

    // Init this carousel
    updateCarousel();
  });
})();

//******************* Script to Ring Size Chart and Enquiry Drawer ************

document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const drawer = document.getElementById('ringsizeDrawer');
  
  // Exit early if drawer doesn't exist on this page
  if (!drawer) {
    return;
  }
  
  // Configuration for different drawer types
  const drawerConfigs = [
    {
      triggerSelector: '.ring_size_trigger',
      contentSelector: '.ring-size-drawer__content'
    },
    {
      triggerSelector: '.enquiry_btn_trigger',
      contentSelector: '.enquiryForm__content'
    }
  ];

  // Function to get current content HTML for a specific config
  function getCurrentContentHTML(configIndex) {
    const config = drawerConfigs[configIndex];
    const contentElement = document.querySelector(config.contentSelector);
    return contentElement ? contentElement.outerHTML : null;
  }

  // Function to add content to drawer
  function addContentToDrawer(contentHTML) {
    if (drawer && contentHTML) {
      drawer.innerHTML = contentHTML;
    }
  }

  // Function to empty drawer content
  function emptyDrawerContent() {
    if (drawer) {
      drawer.innerHTML = '';
    }
  }

  // Function to close drawer
  function closeDrawer() {
    drawer.classList.remove('open');
    body.classList.remove('ring-open');
    emptyDrawerContent();
  }

  // Function to open drawer with specific content
  function openDrawer(contentHTML) {
    addContentToDrawer(contentHTML);
    drawer.classList.add('open');
    body.classList.add('ring-open');
  }

  // Use event delegation for trigger clicks
  document.addEventListener('click', function(e) {
    // Check if clicked element matches any trigger selector
    drawerConfigs.forEach((config, index) => {
      if (e.target.matches(config.triggerSelector) || e.target.closest(config.triggerSelector)) {
        e.preventDefault();
        const isOpen = drawer.classList.contains('open');
        
        if (!isOpen) {
          // Opening drawer - get current content (freshly queried)
          const currentContentHTML = getCurrentContentHTML(index);
          if (currentContentHTML) {
            openDrawer(currentContentHTML);
          }
        } else {
          // Closing drawer
          closeDrawer();
        }
      }
    });
  });

  // Function to check if element matches any trigger selector
  function isElementTrigger(element) {
    return drawerConfigs.some(config => 
      element.matches(config.triggerSelector) || element.closest(config.triggerSelector)
    );
  }

  // Close on clicking outside (using event delegation)
  document.addEventListener('click', function(e) {
    // Only proceed if drawer is open
    if (!drawer.classList.contains('open')) {
      return;
    }
    
    const isClickInsideDrawer = drawer.contains(e.target);
    const isClickOnTrigger = isElementTrigger(e.target);
    
    if (!isClickInsideDrawer && !isClickOnTrigger) {
      closeDrawer();
    }
  });

  // Close on clicking close button inside drawer (already using event delegation)
  document.addEventListener('click', function(e) {
    const closeButton = e.target.closest('#RingSizeDrawerClose');
    if (closeButton && drawer.classList.contains('open')) {
      closeDrawer();
    }
  });
});


//======================================== Mega Menu Component =============================
document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.querySelector('.mobile-menu-toggle');
  const menu = document.querySelector('.nav-parents');

  toggleBtn?.addEventListener('click', function () {
    menu?.classList.toggle('menu-open');
    toggleBtn.classList.toggle('active');
  });

  menu.querySelectorAll('.nav-parent.has-children > a').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      if (window.innerWidth <= 1100) {
        e.preventDefault();

        const clickedParent = this.parentElement;
        const isActive = clickedParent?.classList.contains('active');

        //Remove all active class
        menu.querySelectorAll('.nav-parent.has-children.active').forEach(activeParent => {
          activeParent.classList.remove('active');
        });
        //Adding the parent - active class
        if (!isActive) {
          clickedParent?.classList.add('active');
        }
      }
    });
  });
});
